export enum ModalActionType {
  CANCEL = 'CANCEL',
  SAVE = 'SAVE',
  CONFIRM = 'CONFIRM',
  DELETE = 'DELETE',
  CREATE = 'CREATE',
  BACK = 'BACK',
  EDIT = 'EDIT',
  RESET = 'RESET',
  APPLY = 'APPLY',
  CLOSE = 'CLOSE',
  OPEN_MODAL = 'OPEN_MODAL',
  EMAIL = 'EMAIL',
  CALL = 'CALL',
  TASK = 'TASK',
  NOTE = 'NOTE',
  UPDATE = 'UPDATE',
  VIEW = 'VIEW',
  MOVE_UP = 'MOVE_UP',
  MOVE_DOWN = 'MOVE_DOWN',
  MOVE_TAB = 'MOVE_TAB',
  REFUND = 'REFUND',
  VOID = 'VOID',
  SEND_REMINDER = 'SEND_REMINDER',
  DENY = 'DENY',
}
